module.exports = __webpack_public_path__ + "static/media/prescription.9de682bf.svg";